export default {
  field: {
    label: 'Categoría de impuesto',
    placeholder: 'Sin categoría de impuesto',
    unlinked_hint:
      'Sin una, un producto usa la categoría de impuesto de su categoría de menú o la tarifa estándar del restaurante.',
    default_hint: 'Si se guarda sin una, se aplica la categoría de impuesto predeterminada del menú.',
  },
  empty: {
    hint: 'Aún no hay categorías de impuesto: añade una abajo.',
    read_only_hint: 'Aún no se han configurado categorías de impuestos.',
  },
  option: {
    varies_by_channel: '(varía según el canal)',
  },
  load_error:
    'No se pudieron cargar las categorías de impuesto — vincular y desvincular están deshabilitados hasta que esto cargue.',
  create: {
    name_placeholder: 'Nombre de la nueva categoría',
    rate_placeholder: 'Tasa %',
    button: 'Añadir categoría de impuesto',
  },
  toasts: {
    create_error: 'No se pudo crear la categoría de impuesto.',
  },
};
